export const dropEventKey = 'dropEvent'
export const dropGameKey = 'dropGame'

export const dropDeliveredProductTypesEnum = {
	dropDeliveredKey: 'dropDeliveredKey',
	dropDeliveredCode: 'dropDeliveredCode',
	initialProduct: 'initialProduct',
}

export const brandProductTypesEnum = {
	dropKey: 'dropKey',
	dropCode: 'dropCode',
	customProduct: 'customProduct',
	placeholder: 'placeholder',
}

export const dropEventSubscriptionStatusEnum = {
	PENDING: 'PENDING',
	ACTIVE: 'ACTIVE',
	APPROVED: 'APPROVED',
	EXPIRED: 'EXPIRED',
	INACTIVE: 'INACTIVE',
}

export const dropEventStatusEnum = {
	PENDING_SUBSCRIPTION: 'PENDING_SUBSCRIPTION',
	PENDING_APPROVAL: 'PENDING_APPROVAL',
	PENDING_GO_LIVE_DATE: 'PENDING_GO_LIVE_DATE',
	ACTIVE: 'ACTIVE',
	DEACTIVATED: 'DEACTIVATED',
	EXPIRED: 'EXPIRED',
}

export const dropEventBudgetTypes = {
	MONTHLY: 'MONTHLY',
	CAMPAIGN: 'CAMPAIGN',
}

export const dropEventActivateMethodsEnum = {
	PAYPAL: 'PAYPAL',
	INVOICE: 'INVOICE',
}

export const dropDareDifficultyLevelEnum = {
	n00b: 'n00b',
	easy: 'easy',
	medium: 'medium',
	hard: 'hard',
	legendary: 'legendary',
}

export const readableDropDareDifficultyLevels = {
	[dropDareDifficultyLevelEnum.n00b]: 'N00b',
	[dropDareDifficultyLevelEnum.easy]: 'Easy',
	[dropDareDifficultyLevelEnum.medium]: 'Medium',
	[dropDareDifficultyLevelEnum.hard]: 'Hard',
	[dropDareDifficultyLevelEnum.legendary]: 'Legendary',
}

export const dropDareDifficultyLevelValue = {
	n00b: 0,
	easy: 1,
	medium: 2,
	hard: 3,
	legendary: 4,
}

export const dropDareDifficultyEstimatedTime = {
	n00b: '10 to 30 minutes',
	easy: '30 minutes to 1 hour',
	medium: '1 hour to 3 hours',
	hard: 'Over 3 hours',
	legendary: 'Who knows???',
}

export const dropDareTypeEnum = {
	creative: 'creative',
	gameplay: 'gameplay',
	combat: 'combat',
	speed: 'speed',
	winnings: 'winnings',
	easterEgg: 'easterEgg',
	starter: 'starter',
	other: 'other',
}

export const readableDropDareTypes = {
	[dropDareTypeEnum.creative]: 'Creative',
	[dropDareTypeEnum.gameplay]: 'Gameplay',
	[dropDareTypeEnum.combat]: 'Combat',
	[dropDareTypeEnum.speed]: 'Speed',
	[dropDareTypeEnum.winnings]: 'Winnings',
	[dropDareTypeEnum.easterEgg]: 'Easter Egg',
	[dropDareTypeEnum.starter]: 'Starter',
	[dropDareTypeEnum.other]: 'Other',
}

export const countdownColors = {
	seconds: '#FF007A',
	minutes: '#FFEA00',
	hours: '#5D12E4',
	days: '#00FFED',
}

export const comingSoonMaskText = 'Coming soon'

export const dropEventStatusNames = {
	[dropEventStatusEnum.PENDING_APPROVAL]: 'Pending Approval',
	[dropEventStatusEnum.ACTIVE]: 'Active',
	[dropEventStatusEnum.DEACTIVATED]: 'Deactivated',
	[dropEventStatusEnum.PENDING_GO_LIVE_DATE]: 'Pending Go-Live Date',
	[dropEventStatusEnum.PENDING_SUBSCRIPTION]: 'Pending Subscription',
	[dropEventStatusEnum.EXPIRED]: 'Expired',
}

export const lowProductsTreshold = 11
export const monthyBudgetValues = [500, 1000, 2000, 5000, 10000, 25000, 50000, 75000, 100000]
